// src/constants/constants.js

// Move consts to the top
import logo from "../assets/images/logo.png";
import farmerImage from "../assets/images/farmer.png";
import pakistanMap from "../assets/images/pakistani-map.png";
import productImage from "../assets/images/product.png";
import loginFormImage from "../assets/images/login-page-farmer.png";
import activeAdminsImage from "../assets/images/admins.png";
import deleteIcon from "../assets/icons/Delete.svg";
import calenderIcon from "../assets/icons/calender.svg";
import dropdownIcon from "../assets/icons/dropdown.svg";
import regionIcon from "../assets/icons/regions.svg";
import schedualerIcon from "../assets/icons/schedualer.svg";
import plusIcon from "../assets/icons/plus.svg";
import colorAddPlusIcon from "../assets/icons/colorAddPlusIcon.svg";
import duplicateIcon from "../assets/icons/duplicate.svg";
const supplierImage = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/supplier.png";
const budgetImage = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/budget.png";
const consultantImage = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/consultant.png";


//const consultant = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/consultant.svg";
const farmer = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/farmer.svg";
const finance = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/finance.svg";
const input = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/input.svg";
const other = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/other.svg";
const user = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/user.svg";
const supplier = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/supplier.svg";
const setting = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/setting.svg";
const crops = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/crops.svg";
const logout = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/logout.svg";
const collapse = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/collapse.svg";
const supplierIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/supplier-icon.svg";
const inactivesupplierIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/deactive-supplier.svg";
const activesupplierIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/active-supplier.svg";
const consultantIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/consultant-icon.svg";
const budgetIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/budget-icon.svg";
const farmerIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/farmer-icon.svg";
const inactivefarmerIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/deactive-farmer.svg";
const activefarmerIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/active-farmer.svg";
const yellowfarmerIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/yellow-farmer.svg";
const redfarmerIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/red-farmer.svg";
const logoIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/logo.svg";
const leftIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/left-arrow.svg";
const rightIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/right-arrow.svg";
const languageIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/language.svg";
const pakistanIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/pak.png";
const tickIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/tick.svg";
const crossIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/cross.svg";
const simpleStar = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/simple-star.svg";
const coloredStar = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/colored-star.svg";
const documentIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/document.svg";
const sidebarIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/sidebarIcon.svg";
const viewIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/view-action.svg";
const editIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/edit-action.svg";
const downloadIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/download-action.svg";
const forwardIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/arrow-forward.svg";
const pdfIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/pdfIcon.svg";
const admins = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/admins.svg";
const activeAdmins = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/active-admin.svg";
const activeFarmer = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/active-farmers.svg";
const activeConsultant = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/active-consultants.svg";
const activeSupplier = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/active-suppliers.svg";
const activeOther = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/active-others.svg";
const activeSetting = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/active-setting.svg";
const activeNotification = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/active-notifications.svg";
const Notification = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/notification.svg";
const imageIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/imageIcon.jpg";
const addPlusIcon = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/addPlusIcon.svg";

// const your SVG icons
const consultant = "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/icons/consultant.svg";


// Then define your constants
export const COLORS = {
  primary: "#418E05",
  secondary: "#8AC53E",
  tertiary: "#28a745",
  farmer: "#FF993A",
  budget: "#369FFF",
  supplier: "#8AC53E",
  consultant: "#FFC000",
  dues: "#C80A50",
  profit: "#FDDB1E",
};

export const IMAGES = {
  logo,
  farmerImage,
  supplierImage,
  budgetImage,
  consultantImage,
  productImage,
  pakistanMap,
  loginFormImage,
};

export const ICONS = {
  consultant,
  farmer,
  finance,
  input,
  other,
  user,
  supplier,
  setting,
  crops,
  logout,
  collapse,
  budgetIcon,
  farmerIcon,
  activefarmerIcon,
  inactivefarmerIcon,
  yellowfarmerIcon,
  redfarmerIcon,
  supplierIcon,
  activesupplierIcon,
  inactivesupplierIcon,
  consultantIcon,
  logoIcon,
  leftIcon,
  rightIcon,
  languageIcon,
  pakistanIcon,
  calenderIcon,
  dropdownIcon,
  regionIcon,
  schedualerIcon,
  duplicateIcon,
  plusIcon,
  tickIcon,
  crossIcon,
  simpleStar,
  coloredStar,
  documentIcon,
  sidebarIcon,
  viewIcon,
  editIcon,
  downloadIcon,
  deleteIcon,
  forwardIcon,
  admins,
  pdfIcon,
  imageIcon,
  activeAdmins,
  activeAdminsImage,
  activeFarmer,
  activeSupplier,
  activeConsultant,
  activeSetting,
  activeOther,
  activeNotification,
  Notification,
  addPlusIcon,
  colorAddPlusIcon,
};
